import { Item } from '@emm/core/models/item.model';
import { FormlyFieldConfigMap } from './formly-field-config.map';

const itemGroupingsPlaceHolder = 'Search for an Item/Modifier Grouping';

export const itemGroupingsFilterFieldMap: FormlyFieldConfigMap<Item> = {

    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Item Name',
            maxLength: 512,
            placeholder: itemGroupingsPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    tag: () => ({
        key: 'tag',
        templateOptions: {
            label: 'Item Tag',
            maxLength: 512,
            placeholder: itemGroupingsPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })

};
